import { h, Component } from "preact";
import $ from "jquery";
import GlobState from 'globstate'
import Globals from '../globals.js'
import $ti from '../ti.js'

import * as _ from "../components/index.js";

class Templates extends Component {
  constructor(props) {
    super(props);
    let templates = Globals.Templates();

    this.state = {
      templatesCorrect: 10, //TODO correct answers count
      templatesTotal: templates ? Object.keys(templates).length : 0,
      data: templates
    };
  }

  componentDidMount() {

  }

  render() {
    let data = this.state.data;
    return (
      <>
        <_.Header title="Билеты"/>
        
        <section class="menu">
          {data ? Object.keys(data).map((key)=>(
              <_.Template id={parseInt(key) + 1} data={data[key]}/>
          )) : null}

        </section>
      </>
    );
  }
}

export default GlobState.connect(Templates, Globals)